import Header from "@/components/Header";
import ProgramHero from "@/components/ProgramHero";
import SparkSection from "@/components/SparkSection";
import SparkCertificate from "@/components/SparkCertificate";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";

const SparkRating = () => {
  return (
    <div className="min-h-screen" style={{ background: '#2C003E' }}>
      <SEOHead
        title="Oregon SPARK 5-Star Rating | The Children's Hour Academy"
        description="The Children's Hour Academy holds Oregon's highest SPARK rating — 5 stars for quality early childhood education and childcare in Lake Oswego, OR."
        canonicalPath="/spark-rating"
      />
      <Header />
      <main className="pt-[120px] sm:pt-[150px] md:pt-[170px] lg:pt-[194px]">
        <div>
          <ProgramHero title="OUR SPARK JOURNEY" ageRange="" />
        </div>
      
        {/* Spark Content Section */}
        <section className="py-10" style={{
          background: 'linear-gradient(180deg, #2C003E 0%, #5E2DB4 50%, #7C3AED 100%)'
        }}>
          <div className="space-y-12">
            <div><SparkSection showJourneyText={false} /></div>
            <SparkCertificate />
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default SparkRating;
